import { Routes } from '@angular/router';
import { AuthGuard } from '@auth0/auth0-angular';
import { AccessDeniedRiComponent } from '@r1-development/rps-shared-ui';
import { PAYER_CONFIG_BASE_ROUTE } from './payer-config/constants/payer-config.constants';

export const routes: Routes = [
  {
    path: '',
    redirectTo: PAYER_CONFIG_BASE_ROUTE,
    pathMatch: 'full',
  },
  {
    path: 'callback',
    redirectTo: PAYER_CONFIG_BASE_ROUTE,
    pathMatch: 'full',
  },
  {
    path: PAYER_CONFIG_BASE_ROUTE,
    canActivate: [AuthGuard],
    loadChildren: () => import('./payer-config/payer-config.routes').then((m) => m.payerConfigRoutes),
  },
  // TODO: Temporary redirect for old URL — remove once shared UI is updated
  {
    path: 'payer-rules',
    redirectTo: PAYER_CONFIG_BASE_ROUTE,
    pathMatch: 'prefix',
  },
  {
    path: 'access-denied',
    component: AccessDeniedRiComponent,
    canActivate: [AuthGuard],
    data: { showPageHeader: true },
  },
];
